import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { injectIntl } from "gatsby-plugin-intl";

const AppSnippet = ({ intl, snippet }) => {
  const data = useStaticQuery(graphql`
    query {
      allContentfulAppSnippets {
        nodes {
          node_locale
          callToActionLink
          spokenLanguagesTitle
          showAll
          showLess
          rateCostFrom
        }
      }
    }
  `);

  const snippets = data.allContentfulAppSnippets.nodes.filter(
    (node) => node.node_locale === intl.locale
  );

  return <span>{snippets[0][snippet]}</span>;
};

export default injectIntl(AppSnippet);
